const buildPath = (make, allModels, model) => {
  if (allModels && model.parentModel) {
    const parentModel = allModels.find(
      allModel => allModel._id === model.parentModel
    )
    return `/${make.slug}/${parentModel.slug}/${model.slug}`
  }
  return `/${make.slug}/${model.slug}`
}

export default buildPath
